(function (win, $) {
  'use strict';
  var userRepo = win.tscUserRepository;
  var livechatDeferred = $.Deferred();
  var repo = win.sessionStorage || {
    getItem: $.noop(),
    setItem: $.noop(),
    removeItem: $.noop()
  };
  var displayName = '';
  var email = '';

  var setChatOnlineFlag = function (status) {
    $('html').toggleClass('tsc-chat-online', status === 'online')
      .toggleClass('tsc-chat-offline', status !== 'online');

    updateChatAnnoucement();
  };

  var updateChatAnnoucement = function () {
    var chatStatus = repo.getItem('chatStatus');
    var chatIsOnline = chatStatus === 'online';
    var dataAttribute = chatIsOnline ?
      'chat-online-user-online' : 'chat-offline'; // ignore chat-online-user-offline

    $('.chat-widget-announcement').each(function (i, el) {
      var $wrapper = $(el);
      var $headline = $wrapper.find('.chat-widget-headline');
      var $button = $wrapper.find('.chat-widget-button');
      var chatOnlineUserOnlineClass = $button.data('chat-online-user-online-class') || '';
      var chatOfflineClass = $button.data('chat-offline-class') || '';
      var currentStateClass = '';
      var notCurrentStateClass = '';

      var headlineMarkup = $headline.data(dataAttribute);
      var buttonText = $button.data(dataAttribute) || '';

      $headline.html(headlineMarkup);
      $button.text(buttonText);

      if (chatIsOnline) {
        currentStateClass = chatOnlineUserOnlineClass;
        notCurrentStateClass = chatOfflineClass;
      } else {
        currentStateClass = chatOfflineClass;
        notCurrentStateClass = chatOnlineUserOnlineClass;
      }

      $button.removeClass(notCurrentStateClass);
      $button.addClass(currentStateClass);
    });
  };

  userRepo.getDisplayNameUpdates(function (displayNameValue) {
    displayName = displayNameValue;
  });

  userRepo.getEmailUpdates(function (emailValue) {
    email = emailValue;
  });

  if (!repo.getItem('chatStatus')) {
    repo.setItem('chatStatus', 'pending');
  }

  setChatOnlineFlag(repo.getItem('chatStatus'));

  var filterChatDepartments = function (livechat) {
    var $button = $('.chat-widget-button');
    if (!$button.length) {
      return;
    }

    var departmentData = $button.data('chat-departments') || '';
    var idStrings = departmentData.match(/\d+/g) || [];
    var ids = idStrings.map(function (id) {
      return parseInt(id, 10);
    });

    var allDepartments = win.zE('webWidget:get', 'chat:departments');
    var filtered = ids.filter(function (id) {
      return allDepartments.some(function (department) {
        return id === department.id;
      });
    });

    if (filtered.length === 0) {
      filtered.push(null);
    }

    livechat.departments.filter.apply(livechat.departments, filtered);
  };

  $(function () {
    if (!win.zE) { return; }

    // settings to display choice of chat or create support ticket
    win.zESettings = {
      webWidget: {
        contactOptions: {
          enabled: true,
          contactButton: {
            fr: 'Contactez le support',
            es: 'Soporte de contacto',
            de: 'Kontaktieren Sie Support',
            pt: 'Contate o Suporte',
            ja: 'サポート問い合わせ先',
            '*': 'Contact Support'
          },
          contactFormLabel: {
            fr: 'Créer un ticket',
            es: 'Enviar una solicitud de ayuda',
            de: 'Anfrage einreichen',
            pt: 'Enviar uma consulta',
            ja: 'お問い合わせ',
            '*': 'Submit a Ticket'
          }
        }
      }
    };

    win.zE(function () {
      win.$zopim(function () {
        var livechat = win.$zopim.livechat;
        livechatDeferred.resolve(livechat);

        // filtering is applied when ready in case the widget is already open from previous session
        filterChatDepartments(livechat);

        win.zE('webWidget', 'helpCenter:setSuggestions', { labels: ['support_top_article'] });

        win.zE('webWidget:on', 'chat:status', function (status) {
          // 'online' || 'away' || 'offline'
          repo.setItem('chatStatus', status);
          setChatOnlineFlag(status);
        });

        win.zE('webWidget:on', 'open', function () {
          $(document).trigger('chat_open');
          filterChatDepartments(livechat);
          win.zE('webWidget', 'prefill', {
             name: {
                value: displayName,
                readOnly: false
             },
             email: {
                value: email,
                readOnly: false
             }
          });
        });

        win.zE('webWidget:on', 'userEvent', function (userEvent) {
          if (userEvent.action === 'Chat Served by Operator') {
            $(document).trigger('chat_started');
          }
        });

        win.zE('webWidget:on', 'close', function () {
          $(document).trigger('chat_end');
        });
      });
    });
  });

  $(updateChatAnnoucement);

  $(document).on('click', '.chat-widget-button', function (e) {
    var $button = $(this);
    e.preventDefault();

    if (repo.getItem('chatStatus') !== 'online') {
      document.location.href = $button.data('chat-offline-url');
      return;
    }

    livechatDeferred.then(function (livechat) {
      livechat.window.show();
    });
  });
}(window, jQuery));
